import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker so the home-screen install qualifies as a real
// PWA on iOS + Android. This is what keeps localStorage (and therefore the
// JWT) alive across launches and screen locks.
//
// We DON'T cache the app shell — only registering makes the platform treat
// us as a true PWA. Service worker code lives in /public/service-worker.js.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch(() => { /* silent — SW is best-effort, app works fine without it */ });
  });
}
